import { Component, OnInit } from "@angular/core";
import { BreadcrumbService } from "../../app.breadcrumb.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { RegistroService } from "src/app/services/registro.service";
import { BETWEEN, EQUAL, GREATER_THAN_OR_EQUAL_TO, SearchParams } from "src/app/utilities/util/search/search-params";
import { FormatUtils } from "src/app/utilities/util/format-utils";
import { AbstractService } from "src/app/services/abstract.service";

const ATALHOS = [
    { titulo: "Clientes", descricao: "Cadastro e licenças", icone: "pi pi-id-card", rota: "/clientes/registro", grupos: [1, 2, 3] },
    { titulo: "Consulta", descricao: "Busca rápida de clientes", icone: "pi pi-search", rota: "/clientes/consulta", grupos: [1] },
    { titulo: "Pedidos/Liberações", descricao: "Pedidos e liberações", icone: "pi pi-ticket", rota: "/liberacao", grupos: [1] },
    { titulo: "Atendimentos", descricao: "Registro de atendimentos", icone: "pi pi-phone", rota: "/atendimento", grupos: [1, 2, 3, 4] },
    { titulo: "Logs", descricao: "Logs dos clientes", icone: "pi pi-list", rota: "/logs", grupos: [1, 2, 3, 4] },
    { titulo: "Rejeições fiscais", descricao: "Rejeições da SEFAZ", icone: "pi pi-exclamation-triangle", rota: "/rejeicoes-fiscais", grupos: [1, 2, 3, 4] },
    { titulo: "Bancos de dados", descricao: "Bases dos clientes", icone: "pi pi-database", rota: "/database", grupos: [1, 2, 3] },
    { titulo: "Backups", descricao: "Gerenciador de backups", icone: "pi pi-cloud-download", rota: "/gerenciador-backups", grupos: [1, 2, 3] },
    { titulo: "Relatórios dinâmicos", descricao: "Montar e rodar relatórios", icone: "pi pi-chart-bar", rota: "/relatorios-dinamicos", grupos: [1, 2, 3, 4], acessoRelatorios: ["V", "S"] },
    { titulo: "Contagem de emissão", descricao: "Emissões por cliente", icone: "pi pi-chart-line", rota: "/clientes/contagem", grupos: [1] },
    { titulo: "Usuários", descricao: "Usuários da Central", icone: "pi pi-users", rota: "/adm/usuarios", grupos: [1] },
    { titulo: "Configurações", descricao: "Parâmetros da Central", icone: "pi pi-cog", rota: "/cfg", grupos: [1] },
];

@Component({
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./tabledemo.scss", "./dashboard.component.scss"],
})
export class DashboardDemoComponent implements OnInit {
    urlDev: string = "https://dev.habil10.com.br/snake";
    urlDevSegura: SafeResourceUrl;

    registrosNovos = 0;
    registrosNovosMes = 0;
    vencemHoje = 0;
    venceram30Dias = 0;

    hoje = new Date();
    saudacao = this.hoje.getHours() < 12 ? "Bom dia" : this.hoje.getHours() < 18 ? "Boa tarde" : "Boa noite";
    nomeUsuario = "";
    atalhos: typeof ATALHOS = [];

    constructor(
        private breadcrumbService: BreadcrumbService,
        private sanitizer: DomSanitizer,
        private clienteService: RegistroService,
    ) {
        this.urlDevSegura = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlDev);
        this.breadcrumbService.setItems([
            { label: "Central do Cliente", routerLink: [""] },
        ]);
        this.montaAtalhos();
    }

    montaAtalhos() {
        const usuario = AbstractService.getLocalStorage("usuario");
        if (!usuario) {
            return;
        }
        this.nomeUsuario = (usuario.nome || "").split(" ")[0];
        const grupo = parseInt(String(usuario.grupoAcesso));
        const acessoRelatorios = usuario.acessoRelatorios || "";
        this.atalhos = ATALHOS.filter((a) => {
            if (usuario.sysAdmin) {
                return true;
            }
            if (a.acessoRelatorios && !a.acessoRelatorios.some((f) => acessoRelatorios.includes("." + f + "."))) {
                return false;
            }
            return a.grupos.includes(grupo);
        });
    }

    async ngOnInit() {
        let date = new Date();
        const sp30Dias = FormatUtils.dateStr(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 30));
        const spHoje = FormatUtils.dateStr(new Date());

        let req = this.clienteService.count('',
            [new SearchParams('creationDate', [spHoje], GREATER_THAN_OR_EQUAL_TO)]);
        let ret = await req.toPromise();
        this.registrosNovos = ret;

        req = this.clienteService.count('',
            [new SearchParams('creationDate', [sp30Dias], GREATER_THAN_OR_EQUAL_TO)]);
        ret = await req.toPromise();
        this.registrosNovosMes = ret;

        req = this.clienteService.count('',
            [new SearchParams('habilVencimento', [spHoje], EQUAL)]);
        ret = await req.toPromise();
        this.vencemHoje = ret;

        req = this.clienteService.count('',
            [new SearchParams('habilVencimento', [sp30Dias, spHoje], BETWEEN)]);
        ret = await req.toPromise();
        this.venceram30Dias = ret;
    }

}
